module.exports = __webpack_public_path__ + "static/media/Patrick.af5c0d47.jpg";